module.exports = __webpack_public_path__ + "assets/img/x3.4d151e6a.png";